module.exports = __webpack_public_path__ + "static/media/snoopysnow04.ff7650ff.gif";